/*
  <collection-readmore> wraps the collection hero title + description.
  The description is clamped by CSS (line-clamp, see component-collection-hero.css).
  This shows the Read more / Read less toggle only when the clamp is hiding text.
*/
class CollectionReadmore extends HTMLElement {
  constructor() {
    super();
    this.expanded = false;
    this.check = this.check.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  connectedCallback() {
    this.content = this.querySelector('.collection-hero__description');
    this.button = this.querySelector('#view-more-button');
    if (!this.content || !this.button) return;

    this.label = this.button.querySelector('.view-more-button__label');
    this.button.addEventListener('click', this.toggle);
    this.onResize = typeof debounce === 'function' ? debounce(this.check, 150) : this.check;
    window.addEventListener('resize', this.onResize);

    this.check();
    // Web fonts can change line height after first paint; re-check once they settle.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.check);
  }

  disconnectedCallback() {
    if (this.onResize) window.removeEventListener('resize', this.onResize);
  }

  check() {
    if (this.expanded) return;
    const overflowing = this.content.scrollHeight > this.content.clientHeight + 1;
    this.button.classList.toggle('dis-none', !overflowing);
  }

  toggle(event) {
    if (event) event.preventDefault();
    this.expanded = !this.expanded;
    this.content.classList.toggle('is-expanded', this.expanded);
    this.button.setAttribute('aria-expanded', String(this.expanded));
    if (this.label) {
      this.label.textContent = this.expanded ? this.button.dataset.labelLess : this.button.dataset.labelMore;
    }
    if (!this.expanded) this.check();
  }
}

if (!customElements.get('collection-readmore')) {
  customElements.define('collection-readmore', CollectionReadmore);
}
